var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidentialBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7562,
    cy: 13.2397,
    r: 12.5,
    fill: "#3699FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5433 16.1048V17.363H18.6091V19.2397H17.3126V17.363H15.3783V16.1048H17.3126V14.2263H18.6091V16.1048H20.5433ZM12.6773 5.23975L6.48584 9.88376V19.1648H12.9909V17.6174H8.03326V10.647L12.6773 7.16183L17.3213 10.647V12.1561H18.8687V9.8733L12.6773 5.23975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0575,
    height: 14,
    fill: "white",
    transform: "translate(6.48584 5.23975)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialBuyer);
export default __webpack_public_path__ + "static/media/Residential_buyer.f513dc26b10513043898880a5db5ae49.svg";
export { ForwardRef as ReactComponent };